import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InitialStoreDetailsFinanceFilterData,
  InitialStoreDetailsFinanceFilterDataVariables
} from "./types/InitialStoreDetailsFinanceFilterData";
import {
  StoreDetailsFinance,
  StoreDetailsFinanceVariables
} from "./types/StoreDetailsFinance";
import {
  StoreDetailsFinanceDownload,
  StoreDetailsFinanceDownloadVariables
} from "./types/StoreDetailsFinanceDownload";

export const StoreDetailsFinanceList = gql`
  ${pageInfoFragment}
  query StoreDetailsFinance(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: StoreDetailsFilterInput!
  ) {
    storeDetailsFinance(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          brand_name
          legal_name
          store_type
          store_status
          contract_id
          rental_type
        }
      }
    }
  }
`;

export const useStoreDetailsFinanceQuery = makeBossQuery<
  StoreDetailsFinance,
  StoreDetailsFinanceVariables
>(StoreDetailsFinanceList);

export const StoreDetailsFinanceDownloadQuery = gql`
  ${pageInfoFragment}
  query StoreDetailsFinanceDownload(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: StoreDetailsFilterInput!
  ) {
    storeDetailsFinance(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          brand_name
          legal_name
          vendor_code
          store_type
          store_status
          contract_id
          rental_type
          payment_fee_rate
          vertical
        }
      }
    }
  }
`;
export const useStoreDetailsFinanceDownloadQuery = makeBossQuery<
  StoreDetailsFinanceDownload,
  StoreDetailsFinanceDownloadVariables
>(StoreDetailsFinanceDownloadQuery);

export const InitialStoreDetailsFinanceFilterDataQuery = gql`
  query InitialStoreDetailsFinanceFilterData($brand: [ID], $mall: [ID]) {
    brands(first: 5, filter: { id: $brand }) {
      edges {
        node {
          id
          name
        }
      }
    }

    malls(first: 5, filter: { id: $mall }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const useInitialStoreDetailsFinanceFilterDataQuery = makeQuery<
  InitialStoreDetailsFinanceFilterData,
  InitialStoreDetailsFinanceFilterDataVariables
>(InitialStoreDetailsFinanceFilterDataQuery);
